import { generateMockAnalytics } from './analytics.mock';
import type {
    TimePeriod,
    AnalyticsResponse 
} from '../types';

const USE_MOCK = import.meta.env.DEV || !import.meta.env.VITE_API_URL;

export const analyticsApi = {
    async getAnalytics(
        period: TimePeriod,
        siteIds: string[] = [],
        signal?: AbortSignal
    ): Promise<AnalyticsResponse> {
        if (USE_MOCK) {
            return generateMockAnalytics(period, siteIds);
        }

        const params = new URLSearchParams({
            period,
            sites: siteIds.join(','),
        });

        const response = await fetch(
            `${import.meta.env.VITE_API_URL}/api/analytics&${params}`,
            { signal }
        );

        if (!response.ok) {
            throw new Error(`Analytics API error: ${response.status}`)
        }

        return response.json();
    },

    async exportData(
        period: TimePeriod,
        format: 'csv' | 'png',
        siteIds: string[] = []
    ): Promise<Blob> {
        const params = new URLSearchParams({
            period,
            format,
            sites: siteIds.join(','),
        });

        const response = await fetch(
            `${import.meta.env.VITE_API_URL}/api/analytics/export?${params}`
        );

        if (!response.ok) {
            throw new Error(`Export failed: ${response.status}`);
        }

        return response.blob();
    },
};